export default __webpack_public_path__ + "static/media/Service.5fe67c22.pdf";